document.addEventListener('click', () => {
    document.querySelectorAll('.ro-translation-skip_shipment_button_text').forEach(el => {
        const parentButton = el.closest('.subscription-button');
        parentButton.remove();
    });
});